import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GMarker} from '../models/gmaps/gmarker.model';
import { GPolyline} from '../models/gmaps/gpolyline.model';
import {} from 'googlemaps';

 

Injectable({
    providedIn: "root"
})
export class GMapsService { 

    private _map: google.maps.Map = null;
    
    
    private _gmarkers : google.maps.Marker[] = [];
    private _gpolylines : google.maps.Polyline[] = [];

    private _gpolygonOverlays : any[] = [];
    private _infoWindows : google.maps.InfoWindow[] = [];
 
    private _drawingManager : google.maps.drawing.DrawingManager = null;

    public initMap(mapDiv: any, zoom: number = 15) {
        
        const mapProperties = {
            center: new google.maps.LatLng(41.0082, 28.9784),
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };


		this._map = new google.maps.Map(mapDiv, mapProperties);

		this.setBoundsZoom(zoom);

	}

	private setBoundsZoom(zoom) {

		google.maps.event.addListenerOnce(this._map, 'bounds_changed', function () {
			this.setZoom(Math.min(zoom, this.getZoom()));
		});

	}

    public setClickEventToMap(clickEvent){

        this._map.addListener("click", function(event){
            clickEvent(event);
        })
    }

    public MarkerOperation = new class {

        constructor(public gmapsSuper: GMapsService) {
        }

        public addMarker(input: GMarker, bounds? : google.maps.LatLngBounds) {

            var markerOptions = {
                position: input.position,
                map: this.gmapsSuper._map,
                icon: input.icon,
                title: input.title,
                id : input.id,
				label: input.label,
				animation: input.animation
            };

            this.setBounds(bounds, input.position);

            var marker = new google.maps.Marker(markerOptions);

            this.setClickEvent(marker, input.hasClickEvent);

            this.gmapsSuper._gmarkers.push(marker);
            
            return marker;
        }

        public addMarkers(inputs : GMarker[], bounds? : google.maps.LatLngBounds){

            inputs.forEach(input => {
                
                this.addMarker(input, bounds);

            });

        }

        private setBounds(bounds : google.maps.LatLngBounds, position : any){

            if(bounds){

                bounds.extend(position);

				this.gmapsSuper._map.fitBounds(bounds);

            }

        }

        private setClickEvent(marker : google.maps.Marker,hasClickEvent : boolean){

            if(hasClickEvent){

                let _this = this;

                marker.addListener("click", function(){

                    _this.setInfoWindow(marker);

                })

            }

        }

        private setInfoWindow(marker : google.maps.Marker){

            var title = marker.getTitle();

            let infowindow = new google.maps.InfoWindow({
                content: title,
                maxWidth: 750
            });

            infowindow.open(this.gmapsSuper._map, marker);

            this.gmapsSuper._infoWindows.push(infowindow);
        }

        public deleteMarkers(){

            this.gmapsSuper._gmarkers.forEach(gmarker => {
                gmarker.setMap(null);
            });

        }

        public deleteMarker(id : number){

            var marker = this.gmapsSuper._gmarkers.find(x=>  x.get("id") == id);

            if(marker){
                marker.setMap(null);
            }
		}

    }(this);   

    public PolygonOperation = new class {

        constructor(public gmapsSuper: GMapsService) {
        }

        public generateTool(overlayCompletedEvent, overlayClickEvent){

            if(this.gmapsSuper._drawingManager){
                this.gmapsSuper._drawingManager.setMap(null);
            }

            this.gmapsSuper._drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode:  google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [
                        google.maps.drawing.OverlayType.POLYGON
                    ]
                },
                polygonOptions: {
                    fillColor: "#1E90FF",
                    strokeColor: "#1E90FF"
                },
            });

            this.gmapsSuper._drawingManager.setMap(this.gmapsSuper._map);

            let _this = this;

            this.gmapsSuper._drawingManager.addListener("overlaycomplete", function(polygon){

                //polygon.overlay.id = 1;

                _this.gmapsSuper._gpolygonOverlays.push(polygon.overlay);

                overlayCompletedEvent(polygon);

                polygon.overlay.addListener("mouseup", function (event) {
                    
                    overlayClickEvent(polygon.overlay);

                })
            })
        }

        public deleteOverlays(){

            this.gmapsSuper._gpolygonOverlays.forEach(overlay => {
                overlay.setMap(null);
            });

        }

        public getOverlayArray(overlay){

            let arr_lats = [];
            let arr_lngs = [];

            let rt = [];

            let polygonArray = overlay.getPath().getArray();

            polygonArray.map(function (k, v) {

                let lat = k.lat();
                let lng = k.lng();

                rt.push({ lat : lat, lng : lng });

                //arr_lats.push(lat);
                //arr_lngs.push(lng);

            });

            return rt;
        }

        public checkPointInPolygon(point : google.maps.LatLng, polygon : google.maps.Polygon){

            return google.maps.geometry.poly.containsLocation(point, polygon);

        }

        public changeColor(overlay, newColor = null){
            if(!newColor)
               newColor = this.gmapsSuper.HelperOperation.getRandomColor();

            overlay.set("fillColor", newColor);
        }

    }(this);   

    public PolylineOperation = new class {

        constructor(public gmapsSuper: GMapsService) {
        }

        public generate(input : GPolyline,bounds? : google.maps.LatLngBounds){

            const _this = this;

            //const flightPlanCoordinates = [
            //    { lat: 37.772, lng: -122.214 },
            //    { lat: 21.291, lng: -157.821 },
            //    { lat: -18.142, lng: 178.431 },
            //    { lat: -27.467, lng: 153.027 },
            //  ];

			const polyline = new google.maps.Polyline({
				path: input.coordinates,
				geodesic: true,
				strokeColor: input.strokeColor ? input.strokeColor : "#1E90FF",
				//strokeColor: input.strokeColor ? input.strokeColor : "#FF0000",
				strokeOpacity: 1.0,
				strokeWeight: input.strokeWeight ? input.strokeWeight : 2,
            });

            this.gmapsSuper._gpolylines.push(polyline);

            if(!bounds){

                let bounds = new google.maps.LatLngBounds();

				input.coordinates.forEach(function (item) {

                    var position = new google.maps.LatLng(item.lat, item.lng);
                    
                    _this.gmapsSuper.HelperOperation.setBounds(bounds, position);

                });
            }

            polyline.setMap(this.gmapsSuper._map);

        }

        public deleteAll(){

            this.gmapsSuper._gpolylines.forEach(gpolyline => {
                gpolyline.setMap(null);
            });

        }

        public delete(id : number){

            var polyline = this.gmapsSuper._gpolylines.find(x=>  x.get("id") == id);

            if(polyline){
                polyline.setMap(null);
            }
        }

    }(this);   
    
    public HelperOperation = new class {

        private _color : string[] = ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082', '#FFFF00', '#808000', '#800000', '#0000FF', '#333333', '#009933', '#16A085', '#CD6155'];

        constructor(public gmapsSuper: GMapsService) {
        }

        public getRandomColor(){
            var rndColor = Math.floor(Math.random() * 12);

            var newColor = this._color[rndColor];

            var rt = newColor ? newColor : '#298A08';

            return rt;
        }
        
        public setBounds(bounds : google.maps.LatLngBounds, position : any){

            if(bounds){

                bounds.extend(position);

                this.gmapsSuper._map.fitBounds(bounds);
            }

        }

    }(this); 
	
}

 

//const x1: GMapsService = new GMapsService();


 

// x1.MarkerOperation.addMarker();
